import { 
  collection, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  query, 
  where, 
  orderBy, 
  getDocs,
  Timestamp 
} from 'firebase/firestore';
import { db } from '../config/firebase';
import { TopicComment } from '../types/maintenanceBank';

const COMMENTS_COLLECTION = 'topicComments';

export class TopicCommentsService {
  /**
   * إضافة تعليق جديد
   */
  static async addComment(comment: Omit<TopicComment, 'id' | 'createdAt' | 'updatedAt'>): Promise<string> {
    try {
      const docRef = await addDoc(collection(db, COMMENTS_COLLECTION), {
        ...comment,
        createdAt: Timestamp.now(),
        updatedAt: Timestamp.now()
      });
      
      console.log('✅ تم إضافة التعليق بنجاح:', docRef.id);
      return docRef.id;
    } catch (error) {
      console.error('❌ خطأ في إضافة التعليق:', error);
      throw error;
    }
  }

  /**
   * جلب تعليقات موضوع معين
   */
  static async getCommentsByTopic(topicId: string): Promise<TopicComment[]> {
    try {
      const q = query(
        collection(db, COMMENTS_COLLECTION),
        where('topicId', '==', topicId),
        orderBy('createdAt', 'asc')
      );
      
      const snapshot = await getDocs(q);
      const comments = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        createdAt: doc.data().createdAt?.toDate(),
        updatedAt: doc.data().updatedAt?.toDate(),
        editedAt: doc.data().editedAt?.toDate()
      })) as TopicComment[];

      console.log(`✅ تم جلب ${comments.length} تعليق للموضوع ${topicId}`);
      return comments;
    } catch (error) {
      console.error('❌ خطأ في جلب التعليقات:', error);
      throw error;
    }
  }

  /**
   * تعديل تعليق
   */
  static async updateComment(commentId: string, content: string): Promise<void> {
    try {
      const commentRef = doc(db, COMMENTS_COLLECTION, commentId);
      await updateDoc(commentRef, {
        content,
        isEdited: true,
        editedAt: Timestamp.now(),
        updatedAt: Timestamp.now()
      });
      
      console.log('✅ تم تعديل التعليق بنجاح:', commentId);
    } catch (error) {
      console.error('❌ خطأ في تعديل التعليق:', error);
      throw error;
    }
  }

  /**
   * حذف تعليق
   */
  static async deleteComment(commentId: string): Promise<void> {
    try {
      await deleteDoc(doc(db, COMMENTS_COLLECTION, commentId));
      console.log('✅ تم حذف التعليق بنجاح:', commentId);
    } catch (error) {
      console.error('❌ خطأ في حذف التعليق:', error);
      throw error;
    }
  }

  /**
   * إعجاب بتعليق
   */
  static async likeComment(commentId: string, currentLikes: number): Promise<void> {
    try {
      const commentRef = doc(db, COMMENTS_COLLECTION, commentId);
      await updateDoc(commentRef, {
        likes: currentLikes + 1
      });
      
      console.log('✅ تم الإعجاب بالتعليق:', commentId);
    } catch (error) {
      console.error('❌ خطأ في الإعجاب بالتعليق:', error);
      throw error;
    }
  }

  /**
   * حذف جميع تعليقات موضوع (للاستخدام عند حذف الموضوع)
   */
  static async deleteTopicComments(topicId: string): Promise<void> {
    try {
      const q = query(
        collection(db, COMMENTS_COLLECTION),
        where('topicId', '==', topicId)
      );
      
      const snapshot = await getDocs(q);
      const deletePromises = snapshot.docs.map(doc => deleteDoc(doc.ref));
      await Promise.all(deletePromises);
      
      console.log(`✅ تم حذف ${snapshot.docs.length} تعليق للموضوع ${topicId}`);
    } catch (error) {
      console.error('❌ خطأ في حذف تعليقات الموضوع:', error);
      throw error;
    }
  }
}
